import dayjs from 'dayjs';
var InkyPortStockInfo = /** @class */ (function () {
    function InkyPortStockInfo() {
    }
    InkyPortStockInfo.createFromApi = function (dto) {
        return Object.assign(new InkyPortStockInfo(), dto, {
            lastUpdated: dayjs(dto.lastUpdated).toDate(),
        });
    };
    return InkyPortStockInfo;
}());
export { InkyPortStockInfo };
var InkyPortProductInfo = /** @class */ (function () {
    function InkyPortProductInfo() {
    }
    InkyPortProductInfo.prototype.getStockCount = function () {
        var total = 0;
        for (var i = 0; i < this.stocks.length; i++) {
            total += this.stocks[i].available;
        }
        return total;
    };
    InkyPortProductInfo.createFromApi = function (dto) {
        return Object.assign(new InkyPortProductInfo(), dto, {
            stocks: dto.stocks.map(function (x) { return InkyPortStockInfo.createFromApi(x); }),
        });
    };
    return InkyPortProductInfo;
}());
export { InkyPortProductInfo };
